export default {
    GET_COURSES_REQUEST: 'COURSE_LIST_GET_COURSES_REQUEST',
    GET_COURSES_SUCCESS: 'COURSE_LIST_GET_COURSES_SUCCESS',
    GET_COURSE_STATUSES_REQUEST: 'COURSE_LIST_GET_COURSE_STATUSES_REQUEST',
    GET_COURSE_STATUSES_SUCCESS: 'COURSE_LIST_GET_COURSE_STATUSES_SUCCESS',
    GET_USERS_REQUEST: 'COURSE_LIST_GET_USERS_REQUEST',
    GET_USERS_SUCCESS: 'COURSE_LIST_GET_USERS_SUCCESS',
    BULK_ACTIVATE_COURSES_REQUEST: 'COURSE_LIST_BULK_ACTIVATE_COURSES_REQUEST',
    BULK_ACTIVATE_COURSES_SUCCESS: 'COURSE_LIST_BULK_ACTIVATE_COURSES_SUCCESS',
    BULK_DELETE_OR_ARCHIVE_COURSES_REQUEST: 'COURSE_LIST_BULK_DELETE_OR_ARCHIVE_COURSES_REQUEST',
    BULK_DELETE_OR_ARCHIVE_COURSES_SUCCESS: 'COURSE_LIST_BULK_DELETE_OR_ARCHIVE_COURSES_SUCCESS',
    UPDATE_COURSES_REQUEST: 'COURSE_LIST_UPDATE_COURSES_REQUEST',
    UPDATE_COURSES_SUCCESS: 'COURSE_LIST_UPDATE_COURSES_SUCCESS',
    CACHE_BULK_UPDATE_COURSES: 'COURSE_LIST_CACHE_BULK_UPDATE_COURSES',
    DISPOSE: 'COURSE_LIST_DISPOSE_STORE',
};
